module.exports = __webpack_public_path__ + "18d12cdbf3561f867ffb021783466560.pdf";